<template>
  <v-app>
    <v-content>
      <MainDisplay/>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import MainDisplay from './components/Main';

export default {
  name: 'App',

  components: {
    MainDisplay,
  },

  data: () => ({
    //
  }),
};
</script>
